import React from 'react';

import Box from 'components/Box';
import Icon from 'components/Icon';
import Text from 'components/Text';

import { isToday as dateTimeIsToday, moment } from 'util/dateTime';
import { toI18n } from 'util/i18n';

const ReadListView = ({
  cxEl,
  unreadParticipants,
  readParticipants,
  i18nPath,
  hasAccess,
  readIcon = 'eye',
}) => {
  const allRead = !unreadParticipants.length;
  const allUnread = !readParticipants.length;

  function readAt(readAtInSeconds) {
    if (!readAtInSeconds) {
      return '';
    }

    const date = moment(readAtInSeconds * 1000);
    let time;
    if (dateTimeIsToday(date)) {
      time = `${toI18n('messenger.read_list.today')} ${date.format('hh:mm A')}`;
    } else {
      time = date.format('MM-DD-YYYY hh:mm A');
    }

    return time;
  }

  function renderParticipant(participant, index, isRead) {
    return (
      <Box bb pb={4} row mb={8} vcenter key={index}>
        <Box>
          <Text fs12>{participant.user.name}</Text>
        </Box>
        <Box hright grow>
          {isRead ? (
            <Box row>
              <Box>
                <Icon
                  className={cxEl('icon', 'read-count')}
                  size={16}
                  color="blue"
                  type={readIcon}
                />
              </Box>
              &nbsp;
              <Box>
                <Text fs12>{readAt(participant.read_at)}</Text>
              </Box>
            </Box>
          ) : (
            <Text fs12 i18n={`${i18nPath}.sent_unread`} />
          )}
        </Box>
      </Box>
    );
  }

  function renderParticipantsList(participants, isRead) {
    return participants.map((p, i) => renderParticipant(p, i, isRead));
  }

  if (allRead && allUnread) return null;

  return (
    <Box relative>
      <Box phm ptm pbxxs maxh={300} scrollY>
        {!allUnread && (
          <Box mbm>
            <Box mbm>
              <Box vtop>
                <Text
                  fs14
                  fw400
                  asHTML
                  i18n={`${i18nPath}.have_read`}
                  i18nProps={{
                    count: readParticipants.length,
                  }}
                />
              </Box>
            </Box>
            <Box>{renderParticipantsList(readParticipants, true)}</Box>
          </Box>
        )}

        {!allRead && hasAccess && (
          <Box>
            <Box mbm>
              <Box vtop>
                <Text
                  fs14
                  fw400
                  asHTML
                  i18n={`${i18nPath}.have_unread`}
                  i18nProps={{
                    count: unreadParticipants.length,
                  }}
                />
              </Box>
            </Box>
            <Box>{renderParticipantsList(unreadParticipants, false)}</Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ReadListView;
